import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
import { transfersFromCached } from '../../lib/common'
const gettonKhoState = state => state.tonKho;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}
function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.TONKHO_LIST_API,
    formData
  )

  return handleRequest(request);
}

function exportXlsRequestApi(formData) {
  const url = Constants.TONKHO_EXPORT_API + "?s=" + formData.storeId + "&sd=" + formData.tuNgay + "&ed=" +  formData.denNgay +"&k=" + formData.khoIds + "&kw=" + formData.keyword;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}

function listKhoRequestApi(formData) {
  const request = axiosApi().post(
    Constants.TONKHO_KHO_LIST_API,
    formData
  )

  return handleRequest(request);
}

function detailRequestApi(formData) {
  const request = axiosApi().post(
    Constants.TONKHO_DETAIL_API,
    formData
  )

  return handleRequest(request);
}

function tonKhoUpdateRequestApi(formData) {
  const request = axiosApi().post(
    Constants.TONKHO_UPDATE_API,
    formData
  )

  return handleRequest(request);
}

function tonKhoUploadRequestApi(formData) {
  const request = axiosApi().post(
    Constants.TONKHO_UPLOAD_API,
    formData
  )

  return handleRequest(request);
}
function* tonKhoListRequestFlow() {
  const tonKho = yield select(gettonKhoState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, tonKho.formData)

    // dispatch the action with our widgets!
    yield put(brActions.tonKhoListSuccess(results.data))

  } catch (error) {
    yield put(brActions.tonKhoListError(error))
  }
}

function* tonKhoDetailRequestFlow() {
  const tonKho = yield select(gettonKhoState);
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, tonKho.formData)

    // dispatch the action with our widgets!
    yield put(brActions.tonKhoDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.tonKhoDetailError(error))
  }
}

function* tonKhoUpdateRequestFlow() {
  const tonKho = yield select(gettonKhoState);
  try {
    // grab the client from our action
    const result = yield call(tonKhoUpdateRequestApi, tonKho.formData)

    // dispatch the action with our widgets!
    yield put(brActions.tonKhoUpdateSuccess(result));
  } catch (error) {
    yield put(brActions.tonKhoUpdateError(error))
  }
}

function* khoListRequestFlow({payload}) {
  try {
    // grab the client from our action
    const {data} = yield call(listKhoRequestApi, payload)
    // dispatch the action with our widgets!
    yield put(brActions.khoListSuccess(transfersFromCached(data)))

  } catch (error) {
    yield put(brActions.khoListError(error))
  }
}
function* tonKhoExportXlsRequestFlow() {
  const tonKho = yield select(gettonKhoState);
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, tonKho.formData)
    // dispatch the action with our widgets!
    yield put(brActions.tonKhoExportXlsSuccess(results.data))

  } catch (error) {
    yield put(brActions.tonKhoExportXlsError(error))
  }
}
function* tonKhoUploadRequestFlow(action) {
  const tonKho = yield select(gettonKhoState);
  try {
    // grab the client from our action
    const result = yield call(tonKhoUploadRequestApi, tonKho.formData)

    // dispatch the action with our widgets!
    yield put(brActions.tonKhoUploadSuccess(result));
  } catch (error) {
    yield put(brActions.tonKhoUploadError(error))
  }
}
function* tonKhoWatcher() {
  yield [
    takeLatest(Constants.TONKHO_LIST_REQUESTING, tonKhoListRequestFlow),
    takeLatest(Constants.TONKHO_DETAIL_REQUESTING, tonKhoDetailRequestFlow),
    takeLatest(Constants.TONKHO_UPDATE_REQUESTING, tonKhoUpdateRequestFlow),
    takeLatest(Constants.TONKHO_KHO_LIST_REQUESTING, khoListRequestFlow),
    takeLatest(Constants.TONKHO_EXPORT_REQUESTING, tonKhoExportXlsRequestFlow),
    takeLatest(Constants.TONKHO_UPLOAD_REQUESTING, tonKhoUploadRequestFlow),
  ]
}

export default tonKhoWatcher



// WEBPACK FOOTER //
// ./src/views/TonKho/sagas.js